import AuthFileUploader from "../../common/AuthFileUploader";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../utils/hasPermission";
import { PERM } from "../../../utils/permissions";

export default function ExmployeeInfo(props) {
  const { currentEmployee, displayDetails, className } = props;

  const userInfo = useSelector((state) => state.userInfo);
  const canEditEmp = hasPermission(userInfo.permissions, PERM.ORG_EMP_EDIT);

  const [backgroundImage, setBackgroundImage] = useState(null);

  useEffect(() => {
    if (currentEmployee) {
      setBackgroundImage(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee/image/${currentEmployee.employeeNo}`
      );
    }
  }, [currentEmployee]);

  const onUploaded = (e) => {
    const { file } = e;

    const fileReader = new FileReader();

    fileReader.onload = () => {
      setBackgroundImage(fileReader.result);
    };

    fileReader.readAsDataURL(file);
  };

  return (
    <React.Fragment>
      {currentEmployee && (
        <div className={className}>
          <div className="name">
            {currentEmployee.name} ({currentEmployee.enName})
          </div>
          <div className="title">{currentEmployee.jd}</div>
          <div className="photo">
            <div
              id="employeeImage"
              className="image"
              style={{
                backgroundImage: `url(${backgroundImage})`,
                // backgroundImage: backgroundImage
                //   ? `url(${backgroundImage})`
                //   : `url(
                //     ${process.env.REACT_APP_BECCO_API_URL}/api/employee/image/${currentEmployee.employeeNo}
                //   )`,
              }}
            >
              {(canEditEmp ||
                className == "aboutWithoutPhoneEmail") && (
                <AuthFileUploader
                  icon="edit"
                  selectButtonText=""
                  dialogTrigger="#employeeImage"
                  visible={false}
                  multiple={false}
                  allowedFileExtensions={[
                    ".jpg",
                    ".jtif",
                    ".jpeg",
                    ".png",
                    ".gif",
                    ".tiff",
                  ]}
                  uploadMode={"instantly"}
                  uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/employee/image/${currentEmployee.employeeNo}`}
                  onUploaded={onUploaded}
                />
              )}
            </div>

            {displayDetails && (
              <div className="phone">
                PHONE
                <br />
                <span>
                  {currentEmployee.mob &&
                    `010-${currentEmployee.mob.slice(
                      0,
                      4
                    )}-${currentEmployee.mob.slice(4)}`}
                </span>
              </div>
            )}
            {displayDetails && (
              <div className="email">
                EMAIL
                <br />
                <span>{currentEmployee.email}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
